const breadcrumbSchema = (pathname) => {
    const segments = pathname.split("/").filter(Boolean);

    const items = [
        {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.sujaramahaenterprises.com/"
        }
    ];

    segments.forEach((seg, index) => {
        items.push({
            "@type": "ListItem",
            "position": index + 2,
            "name": seg.charAt(0).toUpperCase() + seg.slice(1),
            "item": `https://www.sujaramahaenterprises.com/${segments
                .slice(0, index + 1)
                .join("/")}`
        });
    });

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items
    };
};

export default breadcrumbSchema;
